<template>
  <!-- <div id="app"> -->
    <v-app style="background-color: #ffffff;">
      <!-- <div id="content-container" fluid> -->
        <Header />
          <v-content class="v-content-container">
            <transition name="slide" mode="out-in">
              <router-view/>
            </transition>
          </v-content>
        <Footer id="footer"/>
      <!-- </div> -->

      <!-- <v-container>
        <v-layout style="height: 100%;">
          <v-flex id="flex-container">
          </v-flex>
        </v-layout>
      </v-container> -->
    </v-app>
  <!-- </div> -->
</template>

<script>
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'
import '../node_modules/slick-carousel/slick/slick.css'
import '../node_modules/slick-carousel/slick/slick-theme.css'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
  // background: url('assets/Background.png') center/cover no-repeat border-box;
}

// #nav {
//   padding: 30px;
//   a {
//     font-weight: bold;
//     color: #2c3e50;
//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }

.v-content-container {
  // display: grid !important;
  // align-content: center;
}

// #flex-container {
//   display: grid;
//   grid-template-rows: 1fr auto 1fr;
// }

// out of v-container; under v-app only
// #content-container {
//   height: 100%;
//   display: grid;
//   grid-template-rows: 1fr auto 1fr;
//   grid-template-columns: 1fr;
// }

#footer {
  align-self: end;
  // position: absolute;
  // bottom: 0;
  // left: 0;
  width: 100%;
}

@keyframes slide-in {
  from {
      transform: translateY(-30px);
      opacity: 0;
  }
  to {
      transform: translateY(0);
      opacity: 1;
  }
}

@keyframes slide-out {
  from {
      transform: translateY(0);
      opacity: 1;
  }
  to {
      transform: translateY(-30px);
      opacity: 0;
  }
}
</style>
